
import { defineComponent, ref, PropType } from "vue";
import { useSpeechState, Article } from "~/composable/useSpeechState";

export default defineComponent({
  name: "ArticleSpeechForShowPage",
  props: {
    articles: {
      type: Array as PropType<Article[]>,
      required: true
    }
  },
  setup(props, { emit }) {
    const {
      speechState: speechState,
      isSpeechSupported,
      isPaused,
      isSpeaking,
      rate,
      playSpeech,
      pauseSpeech,
      cancelSpeech
    } = useSpeechState(props.articles[0].articleId, props.articles, emit);

    const isShowArticleSpeechController = ref(false);
    const toggleArticleSpeechController = () => {
      isShowArticleSpeechController.value = !isShowArticleSpeechController.value;
    };

    const isShowPlaybackSpeedController = ref(false);
    const togglePlaybackSpeedController = () => {
      isShowPlaybackSpeedController.value = !isShowPlaybackSpeedController.value;
    };
    const hidePlaybackSpeedController = () => {
      isShowPlaybackSpeedController.value = false;
    };

    return {
      speechState,
      isSpeechSupported,
      isPaused,
      isSpeaking,
      rate,
      isShowArticleSpeechController,
      isShowPlaybackSpeedController,
      toggleArticleSpeechController,
      togglePlaybackSpeedController,
      hidePlaybackSpeedController,
      playSpeech,
      pauseSpeech,
      cancelSpeech
    };
  }
});

